import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const coWorkers = async (data: { name: string; pageParam: number }) => {
  const { pageParam, name } = data;
  const qs = `?page=${pageParam ?? 1}&q=${name ?? ""}`;
  return axios.get(Routes.CO_WORKERS + qs);
};

export const useCoWorkers = (params: { name: string }) => {
  const { name } = params;
  return useInfiniteQuery({
    queryKey: [Keys.CO_WORKERS_QRY, name],
    queryFn: ({ pageParam = 1 }) => coWorkers({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
